import React from "react";
import { Link } from "react-router-dom";
import { BRAND, waLink } from "@/lib/constants";
import { Heart, ArrowRight, Star } from "lucide-react";

export default function TatiSofia() {
  return (
    <div data-testid="page-tati-sofia">
      <section className="relative min-h-[70vh] overflow-hidden flex items-end">
        <img src={BRAND.banner} alt="Tati & Sofia" className="absolute inset-0 w-full h-full object-cover hero-scale" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A1020] via-[#0A1020]/60 to-transparent" />
        <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 w-full">
          <p className="text-xs tracking-[0.3em] text-[#D4A63D] uppercase mb-4">De ce există această platformă</p>
          <h1 className="font-display text-4xl md:text-6xl lg:text-7xl text-[#F8F8F4] leading-tight">Povestea Tati & Sofia</h1>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <p className="font-quote text-2xl md:text-3xl italic text-[#D4A63D]/90 leading-relaxed border-l-2 border-[#D4A63D] pl-6 mb-12">
          „Această platformă nu este despre o singură poveste. Este despre toate poveștile care nu au fost încă spuse.”
        </p>

        <div className="space-y-6 text-[#F8F8F4]/90 text-base md:text-lg leading-relaxed">
          <p>Sofia avea câțiva ani când totul s-a schimbat. Lumea ei mică — care includea atât pe mama, cât și pe tata — a fost tăiată în două. Nu de un eveniment dramatic. Nu de o tragedie publică. Ci de mii de cuvinte mici, șoptite în absența ei, care, încet, au transformat un tată iubitor într-un străin în propria casă.</p>
          <p>Atunci, am înțeles că nu sunt singur. Că în România, mii — poate zeci de mii — de părinți trăiesc același coșmar invizibil. Părinți cărora copilul le-a fost rupt nu printr-o decizie clară, ci prin manipulare emoțională tăcută. Un fenomen pe care lumea îl numește <em className="font-quote">alienare parentală</em>. Un fenomen care încă nu este pe deplin recunoscut în legislația noastră — deși literatura internațională îl documentează de peste 30 de ani.</p>
          <p>TatiSiSofia.ro s-a născut din această tăcere. Din nevoia de a transforma durerea individuală într-o mișcare colectivă. Din convingerea că orice copil — indiferent de războaiele dintre părinții lui — merită să iubească și să fie iubit de ambii.</p>
        </div>

        <div className="my-16 gold-divider" />

        <h2 className="font-display text-3xl md:text-4xl text-[#F8F8F4] mb-6">Manifest</h2>
        <ul className="space-y-4 text-[#F8F8F4]/90 text-base md:text-lg">
          <li className="flex gap-3"><Star className="w-5 h-5 text-[#D4A63D] mt-1 shrink-0" /> Copilul este pe primul loc — întotdeauna și nenegociabil.</li>
          <li className="flex gap-3"><Star className="w-5 h-5 text-[#D4A63D] mt-1 shrink-0" /> Nu suntem împotriva mamelor. Nu suntem împotriva taților. Suntem pentru copii.</li>
          <li className="flex gap-3"><Star className="w-5 h-5 text-[#D4A63D] mt-1 shrink-0" /> Adevărul contează mai mult decât satisfacția dovedirii lui.</li>
          <li className="flex gap-3"><Star className="w-5 h-5 text-[#D4A63D] mt-1 shrink-0" /> Sistemul trebuie să servească copilul, nu invers.</li>
          <li className="flex gap-3"><Star className="w-5 h-5 text-[#D4A63D] mt-1 shrink-0" /> Niciun părinte iubitor nu trebuie să sufere în tăcere.</li>
        </ul>

        <div className="mt-16 grid sm:grid-cols-2 gap-4">
          <Link to="/spune-povestea" className="cinematic-card rounded-lg p-6 group">
            <div className="text-xs uppercase tracking-widest text-[#D4A63D] mb-2">Implică-te</div>
            <div className="font-display text-xl text-[#F8F8F4] group-hover:text-[#D4A63D] flex items-center gap-2">Spune povestea ta <ArrowRight className="w-4 h-4" /></div>
          </Link>
          <Link to="/doneaza" className="cinematic-card rounded-lg p-6 group">
            <div className="text-xs uppercase tracking-widest text-[#D4A63D] mb-2">Sprijină misiunea</div>
            <div className="font-display text-xl text-[#F8F8F4] group-hover:text-[#D4A63D] flex items-center gap-2">Donează <Heart className="w-4 h-4" /></div>
          </Link>
        </div>
      </section>
    </div>
  );
}
